import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, ChevronsUpDown } from "lucide-react";
import {
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@shadcn-in-nx/ui/dialog";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@shadcn-in-nx/ui/popover";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@shadcn-in-nx/ui/command";
import { cn } from "@shadcn-in-nx/utils";
import Button from "../../../components/Button.jsx";

export default function WorkflowMoveDialog({
    selectedCount,
    availableApps,
    onMove,
    onClose,
}) {
    const { t } = useTranslation();
    const [targetApp, setTargetApp] = useState("");
    const [open, setOpen] = useState(false);

    const selectedApp = availableApps.find((a) => a.id === targetApp);

    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {t("workflowIndex.moveDialog.title")}
                </DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
                <p className="text-sm text-gray-600">
                    {t("workflowIndex.moveDialog.selectApp", {
                        count: selectedCount,
                    })}
                </p>
                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild>
                        <button
                            role="combobox"
                            aria-expanded={open}
                            className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                        >
                            <span className="truncate">
                                {selectedApp?.title ||
                                    t(
                                        "workflowIndex.moveDialog.selectAppPlaceholder"
                                    )}
                            </span>
                            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                        </button>
                    </PopoverTrigger>
                    <PopoverContent
                        className="w-[340px] p-0"
                        align="start"
                        side="bottom"
                        avoidCollisions={false}
                    >
                        <Command>
                            <CommandInput placeholder="Search projects..." />
                            <CommandList className="max-h-[200px]">
                                <CommandEmpty>No projects found.</CommandEmpty>
                                <CommandGroup>
                                    {availableApps.map((app) => (
                                        <CommandItem
                                            key={app.id}
                                            value={app.title}
                                            onSelect={() => {
                                                setTargetApp(app.id);
                                                setOpen(false);
                                            }}
                                        >
                                            <Check
                                                className={cn(
                                                    "mr-2 h-4 w-4 shrink-0",
                                                    targetApp === app.id
                                                        ? "opacity-100"
                                                        : "opacity-0"
                                                )}
                                            />
                                            <span className="font-medium truncate">
                                                {app.title}
                                            </span>
                                        </CommandItem>
                                    ))}
                                </CommandGroup>
                            </CommandList>
                        </Command>
                    </PopoverContent>
                </Popover>
                <div className="flex items-center gap-2 justify-end">
                    <Button variant="outline" onClick={onClose}>
                        {t("workflowIndex.moveDialog.cancel")}
                    </Button>
                    <Button
                        onClick={() => onMove(targetApp)}
                        disabled={!targetApp}
                    >
                        {t("workflowIndex.moveDialog.moveButton")}
                    </Button>
                </div>
            </div>
        </DialogContent>
    );
}
